/**
 *
 */




class PoolContents {

	constructor(poolContObj) {
		if(!(poolContObj.or34 && poolContObj.bit1)) {
			throw new Error('コンストラクターの引数が不正です');
		};

		this._poolContObj = poolContObj;

		if( !!poolContObj.bit1Arr ) {
			this._bit1Arr = poolContObj.bit1Arr;
			this._bit2Arr = poolContObj.bit2Arr;
		}else {
			this._bit1Arr = this._setBitArr(1, poolContObj);
			this._bit2Arr = this._setBitArr(2, poolContObj);
		}

		if(poolContObj.boA) {
			this._booArray = this._poolContObj.boA;
		}else {
			this._booArray = [];
		}


	};

	get or34() {   return this._poolContObj.or34;   };
	get categ() {   return this._poolContObj.cag;   };
	get plus() {   return this._poolContObj.pls;   };
	get bit1() {   return this._poolContObj.bit1;   };
	get bit2() {   return this._poolContObj.bit2;   };
	get bit1Arr() {   return this._bit1Arr;   };
	get bit2Arr() {   return this._bit2Arr;   };
	get totalP() {   return this._poolContObj.toP;   };

	get booArray() {   return this._booArray;   };
	set booArray(boo) {   this._booArray = boo;   };



	//
	_setBitArr(or12, poolContObj) {
		let bitLen = 0;
		let bit12 = this.bit1;
		if(or12===1) {
			if(poolContObj.cag<10) {
				bitLen = poolContObj.or34+1;
			}else if(poolContObj.cag===10){
				bitLen = SPACEALL_NUM[poolContObj.or34-3].length;
			}else {
				bitLen = BAZO_NUM[poolContObj.or34-3].length;
			};
		}else {
			if(poolContObj.cag<10) {   bitLen = 10;   };
			bit12 = this.bit2;
		};

		let bitArr = new Uint8Array(bitLen);
		for(let i=0, n=bitArr.length; i<n; i++) {
			if((Math.pow(2, i) & bit12) > 0) {   bitArr[i]++;   };
		};
		return bitArr;
	};

	// Override
	toString() {
		return '{  or34: '+this.or34+', categ: '+this.categ+', plus: '+this.plus
										+', bit1: '+this.bit1+', bit1Arr: '+this.bit1Arr+', bit2: '+this.bit2+', bit2Arr: '+this.bit2Arr
										+', totalP: '+this.totalP+', booArray.len: '+this.booArray.length+'  }';
	};

	equals(object) {

		if(! object instanceof PoolContents) {
			return false;
		}else {
			if(object.or34!==this.or34) {   return false;   };
			if(object.categ!==this.categ) {   return false;   };
			if(object.plus!==this.plus) {   return false;   };
			if(object.bit1!==this.bit1) {   return false;   };
			if(object.bit2!==this.bit2) {   return false;   };
		};
		return true;
	};




	static poolContentsListMaker(poolContJSONObjList) {

		let list = [];
		for(let i=0, n=poolContJSONObjList.length; i<n; i++) {
			list.push(new PoolContents(poolContJSONObjList[i]));
		}
		return list;
	};



	copy(isSelect=true) {

		this._poolContObj

		let copyObj = {};
		copyObj.or34 = this._poolContObj.or34;
		copyObj.cag = this._poolContObj.cag;
		copyObj.pls = this._poolContObj.pls;
		copyObj.bit2 = this._poolContObj.bit2;
		copyObj.bit2Arr = MyUtility.copyArray( this._bit2Arr );

		if(! isSelect) {
			let bit1RA = MyUtility.copyReverseUint8(this._bit1Arr);
			copyObj.bit1 = MyUtility.arrayToBit(bit1RA);
			copyObj.bit1Arr = bit1RA;
			copyObj.toP = 10000 - this._poolContObj.toP;
		}else {
			copyObj.bit1 = this._poolContObj.bit1;
			copyObj.bit1Arr = MyUtility.copyArray( this._bit1Arr );
			copyObj.toP = this._poolContObj.toP;
		};

		return new PoolContents(copyObj);
	};



}

